import { render, staticRenderFns } from "./LogoFooterFull.vue?vue&type=template&id=ddd3717c&scoped=true"
import script from "./LogoFooterFull.vue?vue&type=script&lang=ts"
export * from "./LogoFooterFull.vue?vue&type=script&lang=ts"
import style0 from "./LogoFooterFull.vue?vue&type=style&index=0&id=ddd3717c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd3717c",
  null
  
)

export default component.exports